import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

interface SmsCampaignViews {
    id?: number;
    name?: string;
    createdAt?: string;
    updatedAt?: string;
    sms_campaign_numbers: {
        sms_gateway_id: number,
        sms_gateway_number_id: number,
    }[],
    sms_campaign_users: number
}

interface SmsCampaignViewState {
    smscampaignviewsdata: SmsCampaignViews[];
    info: { count: number; current_page: number; limit: number; total_page: number } | null;
    error: string | null;
    loading: boolean;
}


// // ==================view-Smscampaign-api-start=============
export const GetSmsCampaignView = createAsyncThunk<
    SmsCampaignViews,
    number,
    { rejectValue: string }
>(
    'smscampaignviewsdata/GetSmsCampaignView',
    async (id, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/api/admin/sms-campaigns/${id}`);
            return response.data.smsCampaign;
        } catch (error: any) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue(error.message);
        }
    }
);
// // ==================view-Smscampaign-api-end============

const initialState: SmsCampaignViewState = {
    smscampaignviewsdata: [],
    info: null,
    error: null,
    loading: false,
};

const smscampaignSlice = createSlice({
    name: "Smscampaign",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(GetSmsCampaignView.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetSmsCampaignView.fulfilled, (state, action: PayloadAction<SmsCampaignViews>) => {
                state.loading = false;
                state.error = null;
                state.smscampaignviewsdata = [action.payload];
            })
            .addCase(GetSmsCampaignView.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});

export default smscampaignSlice.reducer;